import React, { useState } from "react";
import "../../css/FacilitiesPage.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const FACILITIES = [
  { icon: "🎭", name: "Amphi-Theatre" },
  { icon: "🔬", name: "STEM Classes" },
  { icon: "🧪", name: "Science Labs" },
  { icon: "💃", name: "Dance Room" },
  { icon: "🎵", name: "Music Room" },
  { icon: "🎙️", name: "RJ Station" },
  { icon: "🍽️", name: "Cafeteria" },
  { icon: "🖥️", name: "Digital Classrooms" },
  { icon: "🗣️", name: "Language Lab" },
  { icon: "🎬", name: "Theatre Room" },
  { icon: "👩‍🍳", name: "Culinary Lab" },
  { icon: "🤖", name: "Robotics Lab" },
  { icon: "🏛️", name: "Multi-Purpose Hall" },
  { icon: "📺", name: "Audio-Visual Room" },
  { icon: "🎥", name: "Croma Station" },
  { icon: "💻", name: "IT Labs" },
  { icon: "🏥", name: "Sick Bay" },
  { icon: "📚", name: "Library" },
  { icon: "❄️", name: "AC Classrooms" },
  { icon: "🚌", name: "GPS Enabled Buses" },
  { icon: "⚽", name: "Football Ground" },
  { icon: "🏏", name: "Cricket Pitch" },
  { icon: "🏀", name: "Basketball Court" },
  { icon: "🏓", name: "Pickleball Court" },
  { icon: "🤾", name: "Handball Ground" },
  { icon: "🏃", name: "Athletics Track" },
  { icon: "🏸", name: "Badminton Court" },
  { icon: "⛸️", name: "Skating Rink" },
  { icon: "🏐", name: "Volleyball Court" },
  { icon: "🤸", name: "Long Jump Pit" },
  { icon: "🎨", name: "Art & Craft Room" },
  { icon: "♟️", name: "Chess Room" },
];

const SUSTAIN_FEATURES = [
  {
    emoji: "☀️",
    title: "Natural Sunlight",
    desc: "Our campus is designed to let in plenty of natural daylight, keeping classrooms bright and reducing dependence on artificial lighting.",
  },
  {
    emoji: "🌬️",
    title: "Indoor Environment Quality",
    desc: "Careful attention to ventilation, temperature and lighting keeps the air inside our buildings clean and comfortable for students all day.",
  },
  {
    emoji: "🏃‍♂️",
    title: "Physical Health",
    desc: "Green, walkable spaces around the campus encourage students to stay active and make the most of outdoor time between classes.",
  },
  {
    emoji: "💧",
    title: "Rainwater Harvesting",
    desc: "Rooftop rainwater is collected and channelled into recharge pits, helping conserve water for landscaping and daily use.",
  },
  {
    emoji: "♻️",
    title: "Sewage Treatment Plant",
    desc: "Wastewater from the campus is treated on-site and reused for landscaping, minimising overall water wastage.",
  },
];

const FAQ_ITEMS = [
  {
    q: "What makes Sahara Public School's facilities stand out?",
    a: "From spacious, sunlit classrooms to dedicated labs, sports grounds and creative studios, every space at Sahara Public School is designed to give students a comfortable and future-ready learning environment.",
  },
  {
    q: "Does Sahara Public School support holistic development?",
    a: "Yes. Alongside academics, students get access to arts, sports, leadership programs, and hands-on activities that support emotional, social and academic growth.",
  },
  {
    q: "Are the classrooms equipped with modern technology?",
    a: "Our classrooms feature digital panels, interactive learning tools and audio-visual support to make lessons more engaging and easier to understand.",
  },
];

export default function FacilitiesPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="facilities-page">
      {}
      <SchoolHero
        title="Facilities at Sahara Public School"
        subtitle="World-Class Infrastructure"
        image="/images/j.jpeg"
      />
      <section className="facilities-hero">
        <h1>Facilities at Sahara Public School</h1>
        <p>
          From smart classrooms to indoor and outdoor sports arenas, our campus
          is built to support every stage of a student's growth.
        </p>
      </section>

      {}
      <section className="wrap premises-section">
        <div>
          <h2>Our School Premises</h2>
          <p>
            Sahara Public School sits on a spacious campus where most of the
            land is left open, allowing classrooms to stay naturally lit and
            well ventilated throughout the day.
          </p>
          <p>
            Indoor and outdoor activity zones are laid out thoughtfully so
            students can move freely between different facilities, making
            everyday campus life comfortable and enriching.
          </p>
        </div>
        <div className="premises-img">
          <img
            src="./images/fc.jpeg"
            alt="Sahara Public School campus"
          />
        </div>
      </section>

      {}
      <section className="facilities-grid-section">
        <div className="wrap">
          <h2>Campus Facilities</h2>
          <p>
            A wide range of spaces designed to support academics, creativity,
            sports and everyday campus life.
          </p>
          <div className="facilities-grid">
            {FACILITIES.map((f) => (
              <div className="facility-card" key={f.name}>
                <div className="facility-icon">{f.icon}</div>
                <div className="facility-name">{f.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap safety-section">
        <div className="safety-icon-wrap">
          <span className="emoji-badge">🛡️</span>
        </div>
        <div>
          <h2>Safety & Security</h2>
          <p>
            The safety of every student is a top priority. Beyond trained
            security personnel, our campus is monitored by CCTV cameras across
            all key areas to give parents extra peace of mind.
          </p>
          <p>
            Every staff member and support worker who interacts with students,
            directly or indirectly, goes through a thorough background check
            before joining the school.
          </p>
        </div>
      </section>

      {}
      <section className="sustain-section">
        <div className="wrap">
          <h2>Building for a Better Future</h2>
          <div className="sustain-grid">
            {SUSTAIN_FEATURES.map((s) => (
              <div className="sustain-card" key={s.title}>
                <div className="emoji">{s.emoji}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap facilities-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
